import { InvitationDetailsInfo } from "@modules/sharedCoach/components/invitationDetailsInfo"
import { useSidebar } from "@modules/sidebar/hooks/useSidebar"
import { type SidebarNavigatorParams } from "@modules/sidebar/sidebarTypes"
import { ErrorBoundary } from "react-error-boundary"
import { Suspense } from "react"
import { LoadingSpinner } from "@/modules/ui/components/loading"
import { ErrorView } from "@/components/ui/layout/error/errorView"

export const useInvitationSidebar = () => {
  const { sidebarNavigateTo } = useSidebar()

  const navigateToInvitationDetailsInfo = (args: SidebarNavigatorParams) => {
    void sidebarNavigateTo({
      content: (
        <ErrorBoundary fallback={<ErrorView />}>
          <Suspense fallback={<LoadingSpinner />}>
            <InvitationDetailsInfo />
          </Suspense>
        </ErrorBoundary>
      ),
      ...args,
    })
  }

  return { navigateToInvitationDetailsInfo }
}
